<script lang="ts">
    import {location} from 'svelte-spa-router';
    import {season, team} from './store';
    import { onMount } from 'svelte'

    onMount(async() => {

    })

    
</script>
<div>
    

</div>